import type { AlertBannerEntity } from '@supply-mover-2-0/shared';
import { portalFetch } from '../lib/apiClient';

/**
 * Active storefront announcements (PD-14790).
 *
 * Goes through `portalFetch` rather than the shared ApiService because the
 * storefront talks to `/api/portal/*` with a portal token and its own base
 * URL, and because a signed-out shopper must still receive announcements —
 * `portalFetch` omits the Authorization header entirely when there is no
 * token, which is what the optionally-authenticated route expects.
 */
export async function getPortalAnnouncements(
	token: string | null,
): Promise<Array<AlertBannerEntity>> {
	return portalFetch<Array<AlertBannerEntity>>('/announcements', token);
}
